import { render } from "./ContentImage.vue?vue&type=template&id=732dca5a&ts=true"
import script from "./ContentImage.vue?vue&type=script&lang=ts"
export * from "./ContentImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__